import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  previewImage?: string;
}
export function Accordion({
  title,
  children,
  defaultOpen = false,
  previewImage
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="border border-dark-700 bg-dark-800 rounded-lg overflow-hidden mb-4" data-id="element-150">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex flex-col bg-dark-800 hover:bg-dark-700 transition-colors text-left" data-id="element-151">
        {previewImage && <div className="relative w-full h-32 sm:h-40 overflow-hidden" data-id="element-152">
            <img src={previewImage} alt="" aria-hidden="true" className="w-full h-full object-cover object-top" data-id="element-153" />
            {/* Gradient fade so the preview blends into the header */}
            <div className="absolute inset-0 bg-gradient-to-t from-dark-800 via-dark-800/40 to-transparent" data-id="element-154" />
            <span className="absolute bottom-2 left-4 text-[10px] uppercase tracking-widest text-lime-400 font-semibold bg-dark-900/70 px-2 py-0.5 rounded" data-id="element-155">
              Vista previa
            </span>
          </div>}
        <div className="w-full px-6 py-4 flex items-center justify-between" data-id="element-156">
          <span className="font-display text-xl text-white" data-id="element-157">{title}</span>
          <motion.div animate={{
          rotate: isOpen ? 180 : 0
        }} transition={{
          duration: 0.2
        }} data-id="element-158">
            <ChevronDown className="w-6 h-6 text-lime-400 flex-shrink-0" data-id="element-159" />
          </motion.div>
        </div>
      </button>
      <AnimatePresence initial={false} data-id="element-160">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-161">
            <div className="px-6 py-4 border-t border-dark-700 bg-dark-900 text-gray-300" data-id="element-162">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}